import { render, staticRenderFns } from "./help-modal.vue?vue&type=template&id=7464ce58&scoped=true"
import script from "./help-modal.vue?vue&type=script&lang=js"
export * from "./help-modal.vue?vue&type=script&lang=js"
import style0 from "./help-modal.vue?vue&type=style&index=0&id=7464ce58&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7464ce58",
  null
  
)

export default component.exports